import { getRouteApi } from '@tanstack/react-router'
import { useAppStore } from '@/lib/app-store'
import { useHydrated } from '@/hooks/use-hydrated'
import type { RadarStyle } from '@/lib/radar-style'

const rootApi = getRouteApi('__root__')

// Seeded from the root loader's cookie-resolved style, so the SERVER draws the chosen radar and there is no
// classic→rings redraw after hydration. Once hydrated the live store value takes over, so the user-menu toggle
// redraws the radar immediately; both agree on the first client render (same cookie), so the swap is a no-op.
export function useRadarStyle(): RadarStyle {
  const { radarStyle } = rootApi.useLoaderData()
  const fromStore = useAppStore((state) => state.radarStyle)
  const hydrated = useHydrated()
  return hydrated ? fromStore : radarStyle
}
